// @ts-nocheck
import React, { useState } from 'react';
import { loadAllowedSkus } from '../../../../actions/territoryActions';
import { NavLink, useLocation } from 'react-router-dom';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../../common/Table';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import AutoSelectText from '../../../common/AutoSelectText';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import { useTranslation } from 'react-i18next';

function AllowedSkuList({ reload, territoryId }) {
  const { t } = useTranslation();
  const allColumns = [
    'skuName',
    'platform',
    'steamRef',
    'packageId',
    'packageType',
  ];
  const defaultVisibleColumns = allColumns;
  const [games, setGames] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'allowedskulist-settings',
      getTableSettingsDefaults({
        defaultSort: 'skuName',
        defaultVisibleColumns,
      }),
      { territoryId },
      loadAllowedSkus,
      setGames,
      reload,
      t('Failed to load skus')
    );

  // The base config of the columns, this will be filtered based on the visible (above)
  let columnsConfig = [
    {
      Key: 'skuName',
      Label: t('Name'),
      Render: (item) => (
        <>
          <NavLink to={`/sku/${item.skuId}`} className="game-title">
            {item.gameName}
          </NavLink>
          <br />
          <NavLink to={`/sku/${item.skuId}`}>{item.skuName}</NavLink>
        </>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'platform',
      Label: t('Platform'),
      Render: (item) => item.platform,
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'steamRef',
      Label: t('Product code'),
      className: 'autoselect',
      Render: (item) => <AutoSelectText>{item.steamRef || ''}</AutoSelectText>,
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'packageId',
      Label: t('Package Id'),
      className: 'autoselect',
      Render: (item) => <AutoSelectText>{item.packageId}</AutoSelectText>,
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'packageType',
      Label: t('Package type'),
      Render: (item) => item.packageId,
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
  ];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return games ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={games.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={games.totalRowCount}
        filteredRowCount={games.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filterChange={filterChange}
      />
    </KwPanel>
  ) : (
    <Loading></Loading>
  );
}

export default AllowedSkuList;
